import { ReactToExerciseEventType, StartExercise, UpdateObjective } from "Phaser/EventBus";
import Tutorial, { ChapterType, ExerciseScene } from "Types/ExerciseData";
import { AddEventsAndMergeTimestamps, Timestamps } from "Utils/ChaptersToTimestamps";
import timestamps from "./level7.json";

// This is still using the old JSON way of defining levels
const Level7: Tutorial = {
  level: 7,
  end: '2:10',
  videoUrl: 'level-7.mp4',
  sections: [
    {
      chapters: [
        {
          title: 'G in the Bass Clef',
          start: '0:0',
          data: [ChapterType.Lecture]
        },
        {
          title: 'G on the Keyboard',
          start: '0:22',
          data: [ChapterType.Lecture]
        },
        {
          title: 'Find G',
          start: '0:32',
          data: [
            ChapterType.Exercise,
            {
              scene: [
                ExerciseScene.PianoScene,
                {
                  start: 'A0',
                  end: 'C8',
                  transition: 'Dissolve',
                  textPromptPosition: 'Top',
                  objectives: [
                    {
                      text: 'Play G on your keyboard.',
                      target: 'G3',
                    },
                  ],
                },
              ],
              events: [
              ],
            },
          ],
        }
      ]
    },
    {
      chapters: [
        {
          title: 'Playing with the 4th Finger',
          start: '0:38',
          data: [ChapterType.Lecture]
        },
        {
          title: 'Playing G',
          start: '0:42',
          data: [
            ChapterType.Exercise,
            {
              scene: [
                ExerciseScene.NoTimeExercise,
                {
                  centre_align_horizontal: false,
                  padding_x: 550,
                  objectives: [
                    {
                    },
                  ],
                },
              ],
              events: [
              ],
            }
          ]
        },
        {
          title: '4th Finger Technique',
          start: '0:50',
          data: [ChapterType.Lecture]
        },
        {
          title: 'Alternating Fingers',
          start: '1:09',
          data: [
            ChapterType.Exercise,
            {
              scene: [
                ExerciseScene.NoTimeExercise,
                {
                  centre_align_horizontal: true,
                  padding_x: 0,
                  firstObjectiveAppearDelay: 1500,
                  objectives: [
                    {
                    },
                    {
                    },
                    {
                    }
                  ],
                },
              ],
              events: [
              ],
            }
          ]
        },
        {
          title: 'Playing in Time',
          start: '1:32',
          data: [
            ChapterType.Exercise,
            {
              scene: [
                ExerciseScene.StaffExercise,
                {
                  firstObjectiveAppearDelay: 500,
                  objectives: [
                    {
                    },
                    {
                    },
                  ],
                },
              ],
              events: [
              ],
            }
          ]
        }
      ]
    },
    {
      chapters: [
        {
          title: 'Using Both Hands',
          start: '1:48',
          data: [ChapterType.Lecture]
        },
        {
          title: 'Alternating Hands',
          start: '1:56',
          data: [
            ChapterType.Exercise,
            {
              scene: [
                ExerciseScene.StaffExercise,
                {
                  firstObjectiveAppearDelay: 500,
                  objectives: [
                    {
                    },
                    {
                    },
                  ],
                },
              ],
              events: [
              ],
            }
          ]
        }
      ]
    }
  ]
};
export default AddEventsAndMergeTimestamps(timestamps as Timestamps, Level7);
